import { getResponse } from '@satellite/services/serviceUtilities';

export default {
  /**
   * @template TRequest - The type of the request data
   * @template TResponse - The type of the response data
   *
   * Create a comment with improved API contract
   * @param {Object} comment - Comment data
   * @param {string} comment.htmlContent - The HTML content of the comment
   * @param {string} comment.relatedEntity - The related entity type
   * @param {string} comment.relatedId - The related entity ID
   * @param {Object} [options] - Request options
   * @param {import('@satellite/services/serviceUtilities').GetResponseConfig} [options.getResponseConfig] - Response handling options (includeMetaData)
   * @param {import('axios').AxiosRequestConfig<TRequest>} [options.requestConfig] - Axios request config (params, signal, headers, etc.)
   * @returns {Promise<TResponse>} The response data
   */
  async createComment(comment, { getResponseConfig = {}, requestConfig = {} } = {}) {
    const response = await axios.post('/comment', comment, requestConfig);

    return getResponse(response, getResponseConfig);
  }
};
